// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"8f59ae1e","144":"0d436565","232":"2a9f9605","294":"81bcc7f0","501":"b8e47652","547":"1d650cee","585":"16058c76","599":"d89b8995","667":"7ac754ad","814":"7096d13c","926":"281e8f66"}[chunkId] + ".chunk.js";
};